export enum ACTION_TYPES {
  REFRESH = 'CM/CASE/REFRESH/REFRESH',
  RESET = 'CM/CASE/REFRESH/RESET',
}

export interface TRefresh {
  shouldRefresh: boolean;
  fieldsToRefresh: string[];
}
